export default function guaNeedsUpdateQ (groupUA) {
  if (!groupUA) return false
  const needs_update = !groupUA.upToDate
  const THIRTY_DAYS_AGO = Date.now() - 2592000000
  const is_stale = groupUA.lastUpdated < THIRTY_DAYS_AGO
  return (needs_update || is_stale)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/guaNeedsUpdateQ.js